import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-spinner-overlay-wrapper',
  templateUrl: './spinner-overlay-wrapper.component.html',
  styleUrls: ['./spinner-overlay-wrapper.component.scss']
})
export class SpinnerOverlayWrapperComponent implements OnInit {

  @Input() public message             : string ='Loading...';
  @Input() public loginRedirectSpinner: boolean=false;
  @Input() public showSpinner         : boolean=true;
  @Input() public whiteMode           : boolean=false;
  
  constructor() { }

  public ngOnInit() {

  }
}
